import React from "react";
import { FormSection, FormFieldGroup } from "component-library/formSections";
import * as Fields from "./../FieldNames";
import IncludedInPayroll from "../active/IncludedInPayroll";
const DeceasedDetails = ({ onChange, data = {} }) => {
  return (
    <FormSection title={"Deceased Details"} hr>
      <FormFieldGroup
        inputType="singleDatePicker"
        label="Date of Death"
        fieldType="inline"
        inputName={Fields.reactivationDate}
        data={data[Fields.reactivationDate]}
        colSpan="col-lg-3 col-md-3"
        Size={[4, 4, 12, 12]}
        onChange={onChange}
        style={{ marginBottom: "15px" }}
        getToFromValue={onChange}
      />
      <IncludedInPayroll
        label="Should this employee be included in payroll?"
        colSpan="col-lg-3 col-md-3"
        inputName={Fields.deceasedIncludedInPayroll}
        data={data}
        value={data[Fields.deceasedIncludedInPayroll]}
        onChange={onChange}
        middleText="Until which paycheck date"
      />
      <FormFieldGroup
        inputType="textarea"
        inputName={Fields.reactivationDate}
        label="Notes"
        value={data[Fields.reactivationDate]}
        fieldType="inline"
        description="250 characters max"
        rows={6}
        colSpan="col-lg-3 col-md-3"
        Size={[8, 8, 12, 12]}
        onChange={onChange}
        getToFromValue={onChange}
        optional
      />
    </FormSection>
  );
};

export default DeceasedDetails;
